import React, { forwardRef } from 'react'
export default usePath =>
  forwardRef((props, ref) => {
    const path = usePath()
    return <img {...props} src={path(props.src)} ref={ref} />
  })
